import { HREF } from '../constants/href-admin-panel.constant';

export const navigationMenu: { path: string; label: string; icon: string }[] = [
  {
    path: HREF.RESOURCE_UPLOAD,
    label: 'Resource Upload',
    icon: 'drive_folder_upload',
  },
  {
    path: HREF.IMPORTS,
    label: 'Imports',
    icon: 'import_export',
  },
  {
    path: HREF.PRODUCTS,
    label: 'Products',
    icon: 'inventory_2',
  },
  {
    path: HREF.ORDERS,
    label: 'Orders',
    icon: 'receipt_long',
  },
  {
    path: HREF.REFUNDS,
    label: 'Refunds',
    icon: 'currency_exchange',
  },
  // {
  //   path: HREF.HOME,
  //   label: 'Home',
  //   icon: 'home',
  // },
  {
    path: HREF.HERO_IMAGES,
    label: 'Hero images',
    icon: 'photo_library',
  },
  {
    path: HREF.PROMO_BANNERS,
    label: 'Promo Banners',
    icon: 'campaign',
  },
  {
    path: HREF.PAYMENTS,
    label: 'Payments',
    icon: 'payments',
  },
  {
    path: HREF.GENERAL_HOLD,
    label: 'General Hold',
    icon: 'pause_circle',
  },
  // {
  //   path: HREF.FRAUD_HOLD,
  //   label: 'Fraud Hold',
  //   icon: 'gpp_maybe',
  // },
];
